import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { StageMappingService } from '@forwardflow/services/stage-mapping.service'
import useSWR from 'swr'

export const useGetStageMapping = () => {
   return useSWR([QUERY_KEYS.GET_STAGE_MAPPINGS], () =>
      StageMappingService.getStageMapping()
   )
}
